module.exports = __webpack_public_path__ + "img/photo7.c5d13831.png";